<template>
  <div class="background-container overflow-hidden">
    <!-- Background SVG -->
    <svg class="background-svg" viewBox="0 0 100 100" preserveAspectRatio="none">
      <path d="M 0,50 a 50,50 0 1,0 100,0 a 50,50 0 1,0 -100,0" />
    </svg>

    <!-- Content -->
    <div class="content">
      <!-- List Example -->
      <!-- Hero Image with Bounce Effect -->
      <div>
        <v-container fluid>
          <v-row justify="center">
            <v-col cols="12" sm="6" md="4">
              <v-container>
                <div class="responsive-heading">
                  <font size="6">
                    <h2 class="title">Enjoy greater savings and more value when you upgrade your Unifi</h2>
                  </font>
                </div>
              </v-container>
            </v-col>
            <v-col class="hero floating" cols="12" sm="6" md="4">
              <img src="https://unifi.com.my/sites/default/files/page/assets/revamp/aio/FMC_Homepage_Banner_620x400.png"
                class="img">
            </v-col>
          </v-row>
        </v-container>
      </div>
      <p>Count: {{ count }}</p>
      <!-- Grid of Components (Vuetify Grid) -->
      <v-container fluid>
        <v-row justify="center" v-spacing>
          <v-col cols="12" sm="6" md="4">
            <unifiChild mbps="2" mbpslbl="Gbps" monthlyPrice="175" @upgrade="openRegistration" />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <unifiChild2 mbps="1" mbpslbl="Gbps" monthlyPrice="219" @upgrade="openRegistration" />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <unifiChild3 mbps="500" mbpslbl="Mbps" @upgrade="openRegistration" />
          </v-col>
        </v-row>
      </v-container>
    </div>


    <tmReg v-if="showRegistration" :project="selectedPackage" @close="showRegistration = false" />
  </div>
</template>

<script>
import { ref } from 'vue';
import unifiChild from './unifiChild.vue';
import unifiChild2 from './unifiChild2.vue';
import unifiChild3 from './unifiChild3.vue';
import tmReg from './tmReg.vue';

export default {
  name: 'TmNet',
  components: {
    tmReg,
    unifiChild,
    unifiChild2,
    unifiChild3,
  },
 
  setup() {
    const count = ref(0);
    const selectedPackage = ref('');
    const showRegistration = ref(false);

    const increaseCount = (i) => {
      count.value += i;
    };

  
    const openRegistration = (packageName) => {
      showRegistration.value = true;
      console.log('Received upgrade event with package:', packageName);
      selectedPackage.value = packageName;
    
    };

    return {
 
      count,
      selectedPackage,
      showRegistration,
      openRegistration,
      increaseCount,
    };
  },
};
</script>

<style scoped>
/* Hide overflow specifically for this container */
.overflow-hidden {
  overflow: hidden;
}

@media (max-width: 600px) {
  .responsive-heading .title {
    font-size: 24px;
    /* Adjust as needed */
  }
}

@media (min-width: 601px) {
  .responsive-heading .title {
    font-size: 36px;
    /* Adjust as needed */
  }
}

.background-container {
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
}

.background-svg {
  position: absolute;
  left: -142%;
  bottom: 60%;
  width: 350%;
  height: auto;
  fill: rgb(255, 102, 0);
}

.content {
  position: relative;
  z-index: 1;
  padding: 20px;
  text-align: center;
  color: white;
}

.hero {
  margin-top: 20px;
  animation: bounce 1s infinite alternate;
  /* Apply animation directly to .hero */
}

.img {
  max-width: 100%;
}

.title {
  color: rgb(255, 255, 255);
}

/* CSS Animation for Bounce Effect */
@keyframes bounce {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(-10px);
    /* Adjust the amount of bounce */
  }
}
</style>
